export default __webpack_public_path__ + "static/media/contact-mid.9442c6f4.png";